import { BaseActivityEvent } from './BaseActivityEvent'
import { Actor } from './Actor'
import { BaseActivityEventProps } from './Types'
import { InformalFeedbackRequestAction } from './InformalFeedbackRequestAction'
import { useHistory } from 'react-router-dom'
import { ArticleInformalFeedbackViewersCreatedEvent, ArticleInformalFeedbackViewersCoCreatedEvent } from './Types'
import { ProseDisplay } from 'common/ProseInput/ProseDisplay'
import { useReviewsRoutes } from 'hooks/useReviewsRoutes'
import { EventIconContainer } from './EventIconContainer'
import { Approval } from 'blaze-ui/icons'

interface ArticleInformalFeedbackViewersCreatedProps extends Partial<BaseActivityEventProps> {
  event: ArticleInformalFeedbackViewersCreatedEvent | ArticleInformalFeedbackViewersCoCreatedEvent
}

const ArticleInformalFeedbackViewersCreated = ({ event, ...props }: ArticleInformalFeedbackViewersCreatedProps) => {
  const { user, data, article } = event
  const { viewers, request } = data
  const { actions, className, ...rest } = props
  const history = useHistory()
  const reviewRoutes = useReviewsRoutes()

  const handleClick = (e: MouseEvent) => {
    e.stopPropagation()
    history.push(reviewRoutes.show({ slug: article.slug, reviewId: request.id }))
  }

  return (
    <BaseActivityEvent
      {...rest}
      onClick={handleClick}
      icon={
        <EventIconContainer>
          <Approval size={16} />
        </EventIconContainer>
      }
      timestamp={event.timestamp}
      content={
        <>
          <Actor displayName={user.display_name || 'Anonymous User'} userId={user?.id} /> asked{' '}
          <Actor count={viewers.length} displayName={viewers[0]?.display_name} userId={viewers[0]?.id} /> to view #
          {request.key}
        </>
      }
      message={request.html_description ? <ProseDisplay html={request.html_description} /> : request.description}
      actions={
        <>
          <InformalFeedbackRequestAction event={event} />
          {actions}
        </>
      }
    />
  )
}

export { ArticleInformalFeedbackViewersCreated }
